import { type Currency } from "~/api/products/types";
import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";
import { priceFormatter } from "~/utils/price-formatter";

import { ReportRow } from "./ReportRow";

type ReportPriceRowProps = {
  label: string;
  /** Value in cents */
  value: number | string;
  currency: Currency;
  variant?: "default" | "bold" | "indented";
  className?: string;
};

export const ReportPriceRow = ({
  label,
  value,
  currency,
  variant = "default",
  className
}: ReportPriceRowProps) => {
  const { locale } = useCurrentTillLocalisation();

  const formatted = priceFormatter({ value, currency, locale });

  return (
    <ReportRow
      label={label}
      value={formatted}
      variant={variant}
      className={className}
    />
  );
};
